import {
  gmailLabelsToIgnore,
  GMAIL_LABELS_CUT_OFF,
} from '../../config/ignore-gmail-labels';

export interface GmailLabelI {
  id: string;
  name: string;
}

class GmailLabels {
  labels: GmailLabelI[];
  cutoff: number;
  static backgroundColor = 'rgba(183, 63, 131, 0.2)';
  static color = 'rgba(183, 63, 131, 1)';
  constructor(
    original: GmailLabelI[] | undefined,
    cutoff = GMAIL_LABELS_CUT_OFF,
  ) {
    this.labels = GmailLabels.filterIgnore(original);
    this.cutoff = cutoff;
  }
  static filterIgnore(original) {
    if (!original) return [];
    if (typeof original === 'string') {
      original = JSON.parse(original);
    }
    // take care of the case where labels is not array
    if (!Array.isArray(original)) {
      if (typeof original === 'string') original = [];
      else if (original.name) {
        original = [original];
      } else {
        // if == {}
        original = [];
      }
    }
    return original.filter(
      (d) => !gmailLabelsToIgnore.includes(d.name),
    );
  }
  getLabels(): GmailLabelI[] {
    return this.labels;
  }
  getMainLabels(): GmailLabelI[] {
    return this.labels.slice(0, this.cutoff);
  }
  getExtraLabels(): GmailLabelI[] {
    return this.labels.slice(this.cutoff);
  }
  getExtraLabelsCount(): number {
    return this.getExtraLabels().length;
  }
}

export default GmailLabels;
